<template>
    <div class="data-panel">
        <div class="data-panel-header">
            <h2>{{title}}</h2>
            <div class="extra">
                <template v-if="display === 'table'">
                    <a-button @click="exportToExcel(`${api}_table`, `${$service.PROJ_CODE}-${title}-${today.format('YYYY-MM-DD')}`)" :title="$t('common.download')"><a-icon type="download"/></a-button>
                    <a-button @click="copy(`${api}_table`)" id="copy-btn" style="margin:0 16px 0 8px;" :title="$t('common.copy')"><a-icon type="copy"/></a-button>
                </template>
                <template v-if="conf.showDateCompare">
                    <a-date-picker :placeholder="$t('fixed.setDate')" @change="addDate" v-model="date"/>
                    <a-button class="clear_btn" style="margin:0 0 0 8px" @click="clearDate">{{$t("common.clear")}}</a-button>
                </template>
                <a-radio-group v-model="display" style="margin:0 0 0 16px;">
                    <a-radio-button value="chart">{{$t("common.chart")}}</a-radio-button>
                    <a-radio-button value="table">{{$t("common.table")}}</a-radio-button>
                </a-radio-group>
            </div>
        </div>
        <div class="data-panel-content fixed-data-panel-content">
            <chart :datas="chart_datas" :fields="fields" :conf="chart" :height="350" class="fixed-chart" :class="{hidepanel:display!=='chart'}"/>
            <data-table :datas="table_datas" :fields="fields"  :ref="`${api}_table`"  class="fixed-datatable" :class="{hidepanel:display!=='table'}"/>
        </div>
    </div>
</template>

<script>
import Chart from '@/components/common/chart/chart.vue'
import DataTable from '@/components/common/datatable.vue'
import {datatableMixin} from '@/components/common/datatable/datatableMixin.js';
import _ from 'lodash';

export default {
    name: 'comparePanel',
    mixins: [datatableMixin],
    inject: ['today', 'yesterday', 'ranges'],
    components: {
        Chart, DataTable,
    },
    props: {
        // 数据接口
        api: {
            type: String,
        },
        // 标题
        title: {
            type: String,
            default: "数据展示",
        },
        // 图表配置
        chart: {
            type: Object,
            default: ()=>{return {}},
        },
        searchers: {
            type: Object,
            default: ()=>{return {}},
        },
        conf: {
            type: Object,
            default: () => {
                return {
                    type: 'default',
                    showDateCompare: true,
                }
            }
        }
    },
    data() {
        return {
            today_str: this.today.format('YYYY-MM-DD'),
            yesterday_str: this.yesterday.format('YYYY-MM-DD'),
            display: 'chart',
            // 当前选择日期
            date: null,
            // 已选日期
            dates: [],
            datas: {},
        }
    },
    computed: {
        fields() {
            let fields = [this.chart.x]
            if (this.conf.type !== 'device') {
                fields.push({id:this.today_str, title:`${this.$t("common.today")}(${this.today_str})`, num:0})
                fields.push({id:this.yesterday_str, title:`${this.$t("common.yesterday")}(${this.yesterday_str})`, num:1})
                this.dates.forEach((dt, index)=>{
                    if(dt!==this.today_str && dt!==this.yesterday_str) {
                        fields.push({id:dt, title:dt, num:index})
                    }
                });
            } else {
                // 读取table os_name
                const osNameList = _.uniq(this.chart_datas.map(cd => cd[this.chart.series.id]));
                osNameList.forEach((osName, idx) => {
                    fields.push({id: osName, title: osName, num: idx});
                });
            }
            return fields
        },
        chart_datas() {
            let datas = []
            datas = datas.concat(this.datas[this.today_str]?this.datas[this.today_str]:[], this.datas[this.yesterday_str]?this.datas[this.yesterday_str]:[])
            for(let dt of this.dates) {
                if(dt!==this.today_str && dt!==this.yesterday_str) {
                    datas = datas.concat(this.datas[dt]?this.datas[dt]:[])
                }
            }
            return datas
        },
        table_datas() {
            let datas = []
            let group_datas = _.groupBy(this.chart_datas, this.chart.x.id)
            for(let key of Object.keys(group_datas)) {
                let combine_row = {}
                combine_row[this.chart.x.id] = key
                group_datas[key].forEach((row)=>{
                    if (this.conf.type !== 'device') {
                        combine_row[row.dt] = row[this.chart.y.id];
                    } else {
                        combine_row[row[this.chart.series.id]] = row[this.chart.y.id];
                    }
                })
                datas.push(combine_row)
            }
            return datas
        }
    },
    mounted() {
        if(this.searchers.ranges && this.searchers.ranges.default) {
            this.getRanges(this.searchers.ranges.default)
        }
        else {
            this.getData(this.today_str, this.$t("common.today"))
            if (this.conf.type !== 'device') {
                this.getData(this.yesterday_str, this.$t("common.yesterday"))
            }
        }
    },
    methods: {
        // 选择对比日期
        addDate(date, dateString) {
            if(date) {
                this.getData(dateString)
            }
        },
        // 清空对比日期
        clearDate() {
            let datas = {}
            this.dates = [this.today_str, this.yesterday_str]
            for(let date of this.dates) {
                datas[date] = this.datas[date]
            }
            this.datas = datas            
        },
        // 获取数据
        getData(dt, series) {
            // 如果之前没有选择过这一天
            if(this.dates.indexOf(dt) < 0) {
                this.$service.query_fixed_module(this.api, {dt}).then((res)=>{
                    if(!series) {
                        series = dt
                    }
                    let num = this.dates.length
                    res.forEach((d)=>{
                        d['series'] = series
                        d['num'] = num
                    })
                    if(this.dates.indexOf(dt) < 0) {
                        this.dates.push(dt)
                    }
                    this.datas[dt] = res
                })
            }
        },
        // 获取数据
        getRanges(ranges) {
            this.$service.query_fixed_module(this.api, {ranges}).then((res)=>{
             
                const _dates = {}
                res.forEach((d)=>{
                    if(!_dates[d.dt]) {
                        _dates[d.dt] = []
                    }
                    d.series = d.dt
                    d.num = ranges.indexOf(d.dt)
                    _dates[d.dt].push(d)
                })
                ranges.forEach((r, ri)=>{
                    this.datas[r] = _dates[r] || []
                })
                this.dates = ranges
            })
        },
    }
}
</script>